import PropTypes from 'prop-types';

import CheckIcon from '@mui/icons-material/Check';
import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export function ProductBenefits({ benefits }) {
  if (!benefits?.length) {
    return null;
  }

  return (
    <Stack gap={1} sx={{ mt: 1 }}>
      {benefits.map((benefit) => (
        <Stack key={benefit.label} direction="row" alignItems="flex-start" gap={1}>
          <CheckIcon sx={{ color: 'success.main', fontSize: '1.5rem', marginTop: '0.125rem' }} />
          <Box>
            <Text size="sm" weight="bold">
              {benefit.label}
            </Text>
            {benefit.description && (
              <Text size="sm" color="secondary">
                {benefit.description}
              </Text>
            )}
          </Box>
        </Stack>
      ))}
    </Stack>
  );
}

ProductBenefits.propTypes = {
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
  ),
};
